"use client"

import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Box, Typography, Breadcrumbs, Link as MuiLink, CircularProgress } from "@mui/material"
import { Link } from "react-router-dom"
import DashboardLayout from "../components/DashboardLayout"
import StatesTable from "../components/locations/StatesTable"
import { getAllStates } from "../slices/locationSlice"

const LocationsPage = () => {
  const dispatch = useDispatch()
  const { states, loading, error } = useSelector((state) => state.locations)

  useEffect(() => {
    dispatch(getAllStates())
  }, [dispatch])

  return (
    <DashboardLayout>
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <MuiLink component={Link} to="/dashboard" color="inherit">
            Dashboard
          </MuiLink>
          <Typography color="text.primary">Cities</Typography>
        </Breadcrumbs>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            States Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage states and their cities for your WhatsApp campaigns
          </Typography>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ p: 2, bgcolor: "error.light", borderRadius: 1, color: "error.dark" }}>{error}</Box>
        ) : (
          <StatesTable states={states || []} />
        )}
      </Box>
    </DashboardLayout>
  )
}

export default LocationsPage

